import {ApolloError} from 'apollo-server-errors';
import {SerializedPagewebError} from '../../errors/SerializedPagewebError.interface';

export class CustomApolloError extends ApolloError {
  constructor(pagewebError: SerializedPagewebError) {
    super(pagewebError.message, 'CUSTOM_ERROR', pagewebError);
  }
}
